// extracted by mini-css-extract-plugin
module.exports = {"white":"icon_white__3-skN","black":"icon_black__2S3HP","label":"icon_label__3Qu7C","primary":"icon_primary__mTIql","disabled":"icon_disabled__372ZJ"};